import React from "react";
import { Avatar, Card, Divider, Popover } from "antd";
import { CATEGORY_CONFIG } from "variables/constants";
import { Trophy } from "lucide-react";

const mockUsers = [
  {
    id: 1,
    name: "Alice Johnson",
    category: "Culture Hero",
    role: "DevOps Engineer",
    awardMonth: "September 2025",
    achievement:
      "Consistently demonstrated Hyvid values in client interactions and team collaboration",
  },
  {
    id: 2,
    name: "Bob Martinez",
    category: "Values in Action",
    role: "Marketing Manager",
    awardMonth: "October 2025",
    achievement:
      "Delivers exceptional results with clear, measurable impact",
  },
  {
    id: 3,
    name: "Catherine Wu",
    category: "Peak Performer",
    role: "Software Engineer",
    awardMonth: "November 2025",
    achievement:
      "Exceeds targets regularly and improves team efficiency through mentoring",
  },
  {
    id: 4,
    name: "Daniel Kim",
    category: "Innovation Trailblazer",
    role: "Product Designer",
    awardMonth: "October 2025",
    achievement:
      "Introduced new design frameworks that improved user engagement by 25%",
  },
  {
    id: 5,
    name: "Evelyn Park",
    category: "CEO Award",
    role: "Project Manager",
    awardMonth: "December 2025",
    achievement:
      "Leads cross-functional initiatives that generate company-wide value",
  },
  {
    id: 6,
    name: "Franklin Ng",
    category: "AI Adoption Champion",
    role: "Data Scientist",
    awardMonth: "December 2025",
    achievement:
      "Led the team in implementing AI-powered automation tools, increasing productivity by 40%",
  },
];


const AwardeeDetails = ({ name, role, category, awardMonth, achievement }) => {
  const normalizedKey = category.toLowerCase().replace(/\s+/g, "-");
  const { icon: Icon, colorClass } = CATEGORY_CONFIG[normalizedKey] || {};
  const initials = name
      ?.split(" ")
      .map((n) => n[0])
      .join("");

  return (
    <Card className={`rounded-xl card-theme ${colorClass} w-full`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-4 flex-1">
          <div className="relative inline-block">
            <Avatar
              size={64}
              style={{
                background: "linear-gradient(to bottom right, #10b981, #8b5cf6)",
                border: "4px solid white",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              }}
            >
              {initials}
            </Avatar>
            <Popover
              content={category}
              trigger="hover"
              placement="top"
              overlayClassName="reward-popover"
            >
              <div
                className={`absolute -right-1 -bottom-1 w-8 h-8 !rounded-full icon-style ${colorClass} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
              >
                {Icon && <Icon className="w-4 h-4 text-white" />}
              </div>
            </Popover>
          </div>
          <div className="flex flex-col gap-1">
            <h4 className="flex gap-2 font-semibold text-base text-gray-800">
              {name} <Trophy className="w-5 h-5 fill-yellow-500 text-yellow-500"/>
            </h4>
            <p className="text-xs mb-2">{role}</p>
            <span className={`status-indicator ${colorClass} text-xs`}>{category}</span>
          </div>
        </div>

        <div
          className={`w-16 h-16 icon-style ${colorClass} shadow-lg flex items-center justify-center`}
        >
          {Icon && <Icon className="w-8 h-8 text-white" />}
        </div>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="space-y-2">
        <div className="flex items-center justify-between text-[13px]">
          <span className="text-gray-700">Award Month:</span>
          <span className="font-medium">{awardMonth}</span>
        </div>
        <div>
          <p class="mb-2 text-gray-700">Achievement:</p>
          <p class="text-[13px]">{achievement}</p>
        </div>
        <div class="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-4 border border-emerald-200">
          <p class="text-[13px] text-center font-medium text-emerald-700">
            🎉 Congratulations on your outstanding achievement! 🎉
          </p>
        </div>
      </div>

    </Card>
  );
};

const AvatarGrid = () => {
  return (
    <div className="flex gap-4 flex-wrap">
      {mockUsers.map((user) => (
        <AwardeeDetails
          key={user.id}
          category={user.category}
          name={user.name}
          role={user.role}
          awardMonth={user.awardMonth}
          achievement={user.achievement}
        />
      ))}
    </div>
  );
};

export default AvatarGrid;
